'use client';

import { type HTMLAttributes } from 'react';
import { Heading } from '@paypoteam/ui-components';

export interface H3Props extends HTMLAttributes<HTMLHeadingElement> {}

export default function H3({ children, ...props }: H3Props) {
    return (
        <Heading
            type="h3"
            size="4xl"
            {...props}
        >
            {children}
        </Heading>
    );
}
